export default {
    state: {
        wallet: null,
        token: {
            token_symbol: 'ETH'
        },
        modals: {
            wallet: false,
            alert: false,
            approval: false,
            approvalDST: false,
            wrongnetwork: false
        },
        alert: {
            content: ''
        },
        networkId: 0
    },
    mutations: {
        setAccount(state, payload) {
            state.wallet = {
                address: payload.account.address,
                type: payload.wallet,
                balance: payload.account.balance
            };
        },
        clearAccount(state) {
            state.wallet = null;
        },
        setBalance(state, payload) {
            if (state.wallet == null) {
                return;
            }
            state.wallet.balance = payload;
        },
        setStickers(state, payload) {
            if (state.wallet == null) {
                return;
            }
            state.wallet.stickers = payload;
        },
        closeModal(state, payload) {
            state.modals[payload] = false;
        },
        openModal(state, payload) {
            state.modals[payload] = true;
        },
        alert(state, payload) {
            state.alert.content = payload;
            this.commit('openModal', 'alert');
        }
    }
};
